export default "__VITE_ASSET__Cf31eQdL__"